import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
`

export const Title = styled.span`
  font-size: 30px;
  margin-bottom: 20px;
  font-family: ${({ theme }) => theme.fonts.title};
  font-weight: ${({ theme }) => theme.fonts.titleWeight};
  color: ${({ theme }) => theme.colors.text};
`

export const Brand = styled.img`
  width: 90%;
  height: 30%;
  margin-bottom: 20px;
  object-fit: contain;
`
export const Environment = styled.span`
  font-size: 30px;
  margin-bottom: 20px;
  font-family: ${({ theme }) => theme.fonts.title};
  font-weight: ${({ theme }) => theme.fonts.titleWeight};
  color: ${({ theme }) => theme.colors.text};
`

export const ButtonContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
`

export const DebugButtonContainer = styled(ButtonContainer)`
  margin-top: 20px;
  gap: 10px;
`
